import { Injectable } from '@angular/core';
import { AbstractEntityStore } from '@pf/shared-services';
import { PFOrdersEntities } from '@pf/shared-common';
import { PurchaseOrderHeaderRead } from '../../entities/purchase-order-header.dto';

@Injectable()
export class PurchaseOrderHeaderStore extends AbstractEntityStore<PurchaseOrderHeaderRead> {
    constructor() {
        super(PFOrdersEntities.PurchaseOrderHeader);
    }
}
